import { ref, shallowRef, computed } from '@vue/composition-api';
import {
  LayoutFieldItem,
  AreaCodeModel
} from '../model/layout';

import { ActionStore } from './action';
import { layoutStore } from './layouts';
import { useDeleteField } from './deleteField';
import { useFormulaFields } from './formula';

import { checkAddField } from 'common-module/src/api/Subscription';

type OpenDialogStatus = 'add' | 'edit' | 'view';

export const useFields = (
  actionStore: ActionStore,
  layoutStore: layoutStore
) => {
  const dialogVisible = ref<boolean>(false);
  const dialogStatus = ref<OpenDialogStatus>('add');
  const currentEditField = shallowRef<LayoutFieldItem | null>(null);
  const currentEditArea = shallowRef<AreaCodeModel | null>(null);

  // 核对是否可以新增字段
  const checkAddLoading = ref<boolean>(false);
  const fieldRightVisible = ref<boolean>(false);

  // 打开自定义字段（创建/编辑）弹窗
  const openFieldDialog = async (
    status: OpenDialogStatus,
    fieldInfo?: LayoutFieldItem,
    editArea?: AreaCodeModel
  ): Promise<void> => {
    if (status !== 'add') {
      setFieldDialogData(status, fieldInfo, editArea);
      return;
    }
    
    try {
      checkAddLoading.value = true;
      const res = await checkAddField();
      if (res !== '1606') {
        // 打开创建/编辑弹窗
        setFieldDialogData(status, fieldInfo, editArea);
        return;
      }
      // 打开字段权限弹窗
      fieldRightVisible.value = true;
    } finally {
      checkAddLoading.value = false;
    }
  };
  // 设置字段弹窗吃书数据
  const setFieldDialogData = (
    status: OpenDialogStatus,
    fieldInfo?: LayoutFieldItem,
    editArea?: AreaCodeModel
  ): void => {
    dialogVisible.value = true;
    dialogStatus.value = status;
    currentEditField.value = fieldInfo || null;
    currentEditArea.value = editArea || null;
  };
  // 重置数据
  const closeFieldDialog = (): void => {
    fieldRightVisible.value = false;
    dialogVisible.value = false;
    dialogStatus.value = 'add';
    currentEditField.value = null;
    currentEditArea.value = null;
  };

  // 所有字段集合
  const fieldCollection = computed<LayoutFieldItem[]>(() => [
    ...layoutStore.leftAreaFields.value,
    ...layoutStore.rightAreaFields.value,
    ...layoutStore.unusedAreaFields.value,
    ...layoutStore.ignoreFields.value
  ]);

  // 公式字段数据
  const formulaStore = useFormulaFields(
    fieldCollection,
    layoutStore
  );

  // 删除字段
  const projectId = computed(() => actionStore.action.value?.projectId);
  const issueTypeId = computed(() => actionStore.action.value?.issueType?.id);
  const deleteFieldStore = useDeleteField(
    Number(projectId.value),
    Number(issueTypeId.value)
  );

  return {
    fieldRightVisible,
    checkAddLoading,
    showFieldDialog: dialogVisible,
    currentEditField,
    currentEditArea,
    fieldDialogStatus: dialogStatus,
    fieldCollection,
    openFieldDialog,
    closeFieldDialog,
    ...deleteFieldStore,
    ...formulaStore
  };
};

export type FieldStore = ReturnType<typeof useFields>;